import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 1 11.96 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.294071 2.70828C-0.0958032 2.31711 -0.0958032 1.68289 0.294071 1.29172C0.683945 0.900544 1.31606 0.900544 1.70593 1.29172L0.294071 2.70828ZM11.9651 12C11.9651 12.5532 11.5181 13.0017 10.9668 13.0017L1.98176 13.0017C1.4304 13.0017 0.98343 12.5532 0.98343 12C0.98343 11.4468 1.4304 10.9983 1.98176 10.9983L9.96844 10.9983L9.96844 2.98504C9.96844 2.43183 10.4154 1.98337 10.9668 1.98337C11.5181 1.98337 11.9651 2.43183 11.9651 2.98504L11.9651 12ZM1.70593 1.29172L11.6727 11.2917L10.2608 12.7083L0.294071 2.70828L1.70593 1.29172Z",
		fill: "#454545"
	})
});
export default SvgDownArrow;
